import { getTokenInfo } from '../services/auth-config';
import { AuthService } from '../services/auth-service';

export async function authFetchGET(scope: string|undefined, url: string, params?: {[index:string]: string}, headers?: {[index:string]: string})
{
    return _authFetch(scope, url, 'GET', params, headers);
}
export async function authFetchPOST(scope: string|undefined, url: string, payload: any, headers?: {[index:string]: string})
{
    return _authFetch(scope, url, 'POST', payload, headers);
}
export async function authFetchPUT(scope: string|undefined, url: string, payload: any, headers?: {[index:string]: string})
{
    return _authFetch(scope, url, 'PUT', payload, headers);
}
export async function authFetchDELETE(scope: string|undefined, url: string)
{
    return _authFetch(scope, url, 'DELETE');
}

export const TokenExpiredError: string = 'Token expired - needs refresh';

export class FetchStatusCodeError extends Error
{
    readonly response: Response;
    
    constructor(response: Response, message: string)
    {
        super(message);

        this.response = response;
    }
}

async function _authFetch(scope: string|undefined, url: string, method: string, data?: any, headers?: {[index:string]: string})
{
    let request: RequestInit = {
        mode: 'cors',
        cache: 'no-cache',
        method: method,
        headers: { 'Accept': 'application/json' }
    };

    if (headers) {
        request.headers = Object.assign(request.headers!, headers);
    }

    if (scope) {
        //need to pass the id token -that has user roles information
        const idToken = getTokenInfo();
        if(!idToken) throw Error('Token expired - needs re-login');
        (<Record<string,string>>request.headers).Authorization = `Bearer ${idToken}`;
    }

    let response: Response;
    switch(method) {
    case 'GET':
        let searchString = '';
        if (data) {
            const searchParams = new URLSearchParams();
            
            for (const [key, value] of Object.entries(<{[index:string]: string}>data)) {
                searchParams.set(key, value);        
            }
            
            searchString = `?${searchParams.toString()}`;
        }
        
        response = await fetch(`${url}${searchString}`, request);
        break;
    case 'POST':
        if(data?.type === "FleetNPS"){
            (<Record<string,string>>request.headers)["x-auth"] = '{"type":"system"}';
        }
    case 'PUT':
        request.body = JSON.stringify(data);
        (<Record<string,string>>request.headers)['Content-type'] = 'application/json';
        response = await fetch(url, request);
        break;

    case 'DELETE':
        response = await fetch(url, request);
        break;

    default:
        throw Error(`Invalid method [${method}]`);
        break;
    }

    if (response.status === 401) {
        throw new FetchStatusCodeError(response, TokenExpiredError);
    }

    if (response.status < 200 || response.status >= 300) {
        throw new FetchStatusCodeError(response, `Error fetching data: ${response.statusText}`);
    }

    if (response.status !== 204 && response.status !== 202) {
        try {
            return await response.json();
        } catch (err) {
            throw Error('Response data not valid JSON');
        }
    }
};

export async function authFetchFile(
    scope: string | undefined,
    url: string,
    headers?: { [index: string]: string }
): Promise<Response> {
    const request: RequestInit = {
        mode: 'cors',
        cache: 'no-cache',
        method: 'GET',
        headers: { Accept: 'application/pdf' },
    };
 
    if (headers) {
        request.headers = { ...request.headers, ...headers };
    }
 
    if (scope) {
        try {
            const accessToken  = getTokenInfo();
            if (!accessToken) throw new Error(TokenExpiredError)
            ;(<Record<string, string>>(
                request.headers
            )).Authorization = `Bearer ${accessToken}`
        } catch (error) {
            console.error('Error getting access token:', error);
            throw error;
        }
    }
 
    try {
        const response = await fetch(url, request);
 
        if (response.status === 401) {
            throw new Error('Unauthorized - Token expired or invalid');
        }
        if (!response.ok) {
            throw new FetchStatusCodeError(
                response,
                `Error fetching file: ${response.statusText}`
            );
        }
 
        return response;
    } catch (error) {
        console.error(`Error fetching file: ${error}`);
        throw error;
    }
}
